module.exports = __webpack_public_path__ + "img/bjh.cf333ed5.png";